import { OneVerifyIntegrationCategory } from "@common-shared/types/integrations.types"

export enum OneVerifyEraUploadFileFormat {
    csv = "csv",
    x12 = "x12",
}

export const COMMON_ONE_VERIFY_INTEGRATIONS_CONFIG = {
    get categoryLabelMapping(): Record<OneVerifyIntegrationCategory, string> {
        return {
            [OneVerifyIntegrationCategory.eraData]: "ERA Data",
            [OneVerifyIntegrationCategory.ehr]: "EHR",
        }
    },

    eraUpload: {
        integrationId: "uploadEra",

        // S3 key prefix under the One Verify general bucket (practice id substituted server-side).
        s3KeyPrefix: "era-uploads/{{practiceId}}/",

        // Daily ERA ingest run in Eastern Time (frontend display copy / countdown).
        dailyIngestRunHourEt: 9,
        dailyIngestTimezone: "America/New_York",

        maxFilesPerUpload: 50,

        maxFileSizeBytes: 250 * 1024 * 1024, // 250MB

        allowedCsvExtension: "csv",

        get allowedX12Extensions(): string[] {
            return ["835", "edi", "era", "txt"]
        },

        // X12 extensions uploaded as text/plain rather than application/edi-x12
        // .txt is ambiguous (X12 vs CSV) and is sniffed client-side before upload
        get x12PlainTextExtensions(): string[] {
            return ["txt"]
        },

        formatX12ExtensionsLabel(): string {
            return COMMON_ONE_VERIFY_INTEGRATIONS_CONFIG.eraUpload.allowedX12Extensions
                .map(extension => `.${extension}`)
                .join(", ")
        },

        isAllowedX12Extension(extension?: string): boolean {
            return (
                !!extension &&
                COMMON_ONE_VERIFY_INTEGRATIONS_CONFIG.eraUpload.allowedX12Extensions.includes(
                    extension,
                )
            )
        },

        isX12PlainTextExtension(extension?: string): boolean {
            return (
                !!extension &&
                COMMON_ONE_VERIFY_INTEGRATIONS_CONFIG.eraUpload.x12PlainTextExtensions.includes(
                    extension,
                )
            )
        },

        isX12EdiContentTypeExtension(extension?: string): boolean {
            return (
                !!extension &&
                COMMON_ONE_VERIFY_INTEGRATIONS_CONFIG.eraUpload.allowedX12Extensions.includes(
                    extension,
                ) &&
                !COMMON_ONE_VERIFY_INTEGRATIONS_CONFIG.eraUpload.x12PlainTextExtensions.includes(
                    extension,
                )
            )
        },

        resolveX12ContentType(extension?: string): string {
            return this.isX12EdiContentTypeExtension(extension)
                ? "application/edi-x12"
                : "text/plain"
        },
    },
}
